import { Component, OnInit, HostListener, ElementRef, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { DonneReferenceService } from '../../services/donne-reference.service';
import { FeatureToggleService } from '../../../core/services/feature-toggle.service';
import { ClickToCallBackService } from '../../services/click-to-call-back.service';
import { SafeUrl } from '@angular/platform-browser';
import { MPM_CLICKTOCALLBACK_VISIBILITY } from '../../../../configs/toggles.config';

@Component({
  selector: 'app-boite-contact',
  templateUrl: './boite-contact.component.html',
  styleUrls: ['./boite-contact.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('180ms ease-in-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('180ms ease-in-out', style({ opacity: 0 }))])
    ])
  ],
  standalone: false
})
export class BoiteContactComponent implements OnInit {
  @Input()
  buttonStyle: 'default' | 'textOnly' | 'textAndIcon' | 'arrowButtonPrimary' | 'compactButton' = 'default';

  @Input()
  isDSD: boolean;

  @Input()
  buttonText = 'header.click-to-call.titre';

  estAffiche = false;
  telephoneSansFrais: string;
  telephoneMontreal: string;
  isTooltipVisible = false;
  clickToCallBackUrl: SafeUrl = '';
  isClickToCallBackEnabled = false;

  constructor(
    private readonly _donneeReferencesService: DonneReferenceService,
    private readonly elementRef: ElementRef,
    private readonly _featureToggleService: FeatureToggleService,
    private readonly _clickToCallBackService: ClickToCallBackService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    const ref = this._donneeReferencesService.numerosDemandeSupport;
    this.telephoneSansFrais = ref.sansFrais;
    this.telephoneMontreal = ref.montreal;
    this.isClickToCallBackEnabled = this._featureToggleService.hasFeatures(MPM_CLICKTOCALLBACK_VISIBILITY.On);
    this.clickToCallBackUrl = this._clickToCallBackService.url;
  }

  private modifierEtat() {
    this._clickToCallBackService.addDemandeSupport();
  }

  private toggleTooltipVisibility() {
    this.isTooltipVisible = !this.isTooltipVisible;
  }

  @HostListener('document:click', ['$event'])
  clickOutTooltip(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isTooltipVisible = false;
    }
  }

  linkClick(event: Event) {
    event.stopPropagation(); // Ne pas déclencher le clic sur l'élément qui contient le CTCMB
    this.modifierEtat();
  }

  buttonClick() {
    this.modifierEtat();
    this._clickToCallBackService.openInNewTab();
  }
}
